import React from 'react';

const Home = () => {

    return (
        <div className='container-fluid'>
            <div id="up" className='about-me'>
                <p className='about-me'>
                    <br></br>
                    <br></br>
                    <strong>
                        <p>They say Rome wasn't built in a day.</p>
                        <p>Neither will my new website.</p>
                        <p>Stay tuned for the good stuff.</p>
                    </strong>
                </p>
            </div>
        </div >
    )
}

export default Home;